import { Text, View } from '@react-pdf/renderer';
import { styles } from './PDFStyles';

// No props interface needed as we're using render prop

export function PDFFooter() {
  return (
    <View style={styles.footer} render={({ pageNumber }) => (
      <View style={styles.footerContent}>
        <Text style={styles.copyright}>
          © {new Date().getFullYear()} The Channel List. All rights reserved.
        </Text>
        <Text style={styles.pageNumber}>
          Page {pageNumber}
        </Text>
      </View>
    )} fixed />
  );
} 